import { DataTable } from '@/components/shared/DataTable'
import { Button } from '@/components/ui/button'
import { useNavigation, useResource } from '@refinedev/core'
import { toTitleCase } from '@/lib/utils'
import { RESOURCE_DESCRIPTIONS } from '@/resources/fieldSchema'
import { Plus } from 'lucide-react'

export function ListPage({ resource }: { resource: string }) {
  const { create } = useNavigation()
  const { resource: resourceConfig } = useResource({ resourceName: resource })
  const searchField = resourceConfig?.meta?.searchField as string | undefined
  const searchFields = resourceConfig?.meta?.searchFields as string[] | undefined
  const description = RESOURCE_DESCRIPTIONS[resource]

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h1 className="text-xl font-semibold tracking-tight">{toTitleCase(resource)}</h1>
          <p className="text-sm text-muted-foreground mt-0.5">Manage {toTitleCase(resource).toLowerCase()} records</p>
        </div>
        <Button
          className="bg-[#076698] hover:bg-[#055580] text-white shrink-0"
          size="sm"
          onClick={() => create(resource)}
        >
          <Plus size={14} className="mr-1.5" />
          Create
        </Button>
      </div>
      {description && (
        <div className="rounded-xl border border-[#076698]/20 bg-[#e0f0f7]/40 p-4 text-sm text-slate-600 leading-relaxed">
          {description}
        </div>
      )}
      <DataTable key={resource} resource={resource} searchField={searchField} searchFields={searchFields} />
    </div>
  )
}
